module.exports = __webpack_public_path__ + "static/img/model-bg34.a214dbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg34.jpg
// module id = 8L6z
// module chunks = 0